import request from '../../utils/request';

/** 查询推理实例列表（配置与运行时状态已按 id 合并） */
export function fetchInferenceStatus() {
  return request.get('/blissrose/status');
}

/** 查询显卡实时状态（ml-services 跑 nvidia-smi）；取不到时回空数组而非报错 */
export function fetchGpuStatus() {
  return request.get('/blissrose/gpu');
}

/** 新建推理实例：只需传 model_id，checkpoint / model_type / size / class_names 由后端推导 */
export function createInstance(body) {
  return request.post('/blissrose/instances', body);
}

/** 修改推理实例；可只传要改的字段 */
export function updateInstance(id, body) {
  return request.put(`/blissrose/instances/${id}`, body);
}

/** 删除推理实例（默认实例不可删） */
export function deleteInstance(id) {
  return request.delete(`/blissrose/instances/${id}`);
}

/** 加载模型到显存 */
export function startInstance(id) {
  return request.post(`/blissrose/instances/${id}/start`);
}

/** 从显存卸载模型 */
export function stopInstance(id) {
  return request.post(`/blissrose/instances/${id}/stop`);
}

/** 查询已上传模型列表；metrics 是导入时存下的 run 元数据 */
export function fetchModels() {
  return request.get('/blissrose/platform/models');
}

/** 上传模型权重（multipart）：只收 .pt，别的后缀一律 400 */
export function uploadModel(file, meta = {}) {
  const form = new FormData();
  form.append('file', file);
  if (meta.name) form.append('name', meta.name);
  if (meta.model_type) form.append('model_type', meta.model_type);
  if (meta.class_names) form.append('class_names', meta.class_names);
  if (meta.weight_type) form.append('weight_type', meta.weight_type);
  // 不显式设 Content-Type：浏览器自行补 multipart boundary
  // 权重数百 MB，默认 30s 不够用；超时与后端 uploadTimeout 对齐
  return request.post('/blissrose/platform/models/upload', form, { timeout: 300000 });
}

/** 改模型的权重类型（基础权重／训练产物）：只改标注，不动文件 */
export function updateModelWeightType(id, weightType) {
  return request.post(`/blissrose/platform/models/${id}/weight-type`, { weight_type: weightType });
}

/** 查询 MinIO 上可导入的训练 run（只列含 best.pt 的目录） */
export function fetchMinioCandidates() {
  return request.get('/blissrose/platform/models/minio-candidates');
}

/** 从 MinIO 导入一个训练 run 的权重（ml-services 拉到部署机，耗时同上传量级） */
export function importModelFromMinio(payload) {
  return request.post('/blissrose/platform/models/import', payload, { timeout: 300000 });
}

/** 查询模型在 MinIO 上的产物清单（name 为含前缀的完整对象名） */
export function fetchModelObjects(id) {
  return request.get(`/blissrose/platform/models/${id}/objects`);
}

/** 删除模型权重；被推理实例引用的删不掉，原因由后端返回 */
export function deleteModel(id) {
  return request.delete(`/blissrose/platform/models/${id}`);
}
